import "../../assets/css/dashboard/dashboard.css"

import { useEffect, useState } from "react"
import axios from "axios"
import Swal from "sweetalert2"
import SuppliersDashboardTable from "./SuppliersDashboardTable.jsx"
import { useCallback } from "react"
import { useAuth } from "../../context/auth-user.jsx"

const { 
	REACT_APP_URI_DASHBOARD: URI_DASHBOARD,
	REACT_APP_URI_DASHBOARD_TABLE: URI_DASHBOARD_TABLE,
} = process.env

const INFOCARDS_TITLE = [
	{ title: 'Active suppliers', value: 0 },
	{ title: 'Authorized suppliers', value: 0 },
	{ title: 'New request suppliers', value: 0 },
	{ title: 'Pre authorized suppliers', value: 0 },
	{ title: 'Hold payment', value: 0 },
	{ title: 'Compliance suppliers', value: 0 },
	{ title: 'Non compliance suppliers', value: 0 },
	{ title: 'Avg. document upload time', value: "0 days" }
]

export default function Dashboard({ darkLightMode }) {
	//VARIABLE TO MANAGE WHOS LOG IN
	const { user } = useAuth()
	const userLogged = user?.selectedProfile

	// VARIABLE TO MANAGE THE INFORMATION FOR THE DASHBOARD
	const [dashboardInformation, setDashboardInformation] = useState(null)
	const [loadingInfo, setLoadingInfo] = useState(false)
	const [dashboardTable, setDashboardTable] = useState(null)
	// Cache local para data de tabla: { cacheKey: data }
	const [cache, setCache] = useState({})

	const getDashboardInformation = useCallback(async ({ signal }) => {
		try {
			const query = new URLSearchParams();
			query.append("rol", userLogged?.rol);
			query.append("dataID", userLogged?.dataID);
			
			setLoadingInfo(true);
			
			const { data } = await axios.get(`${URI_DASHBOARD}?${query.toString()}`, { signal });

			setDashboardInformation(data);
		} catch (error) {
			const errorMessage = error.response?.data?.message || "An error occurred while fetching dashboard information.";
			console.error("Error fetching dashboard information: ", errorMessage);
		} finally {
			setLoadingInfo(false);
		}
	}, [userLogged]);

	useEffect(() => {
		const controller = new AbortController();

		const { signal } = controller;

		if (!userLogged) return

		getDashboardInformation({ signal })
	}, [userLogged, getDashboardInformation])
	
	const getDashboardTable = useCallback(async ({ userLogged, signal, search = "", orderBy = "companyName", order = "ASC", page = 1, limit = 20 }) => {
		try {
			// Construir clave de cache basada en filtros y paginación
			const cacheKey = `${search}__${orderBy}:${order}__page:${page}__limit:${limit}`
			// Si existe en cache, usarlo y omitir fetch
			if (cache[cacheKey]) {
				setDashboardTable(cache[cacheKey])
				return cache[cacheKey]
			}

			const query = new URLSearchParams();

			query.append("rol", userLogged?.rol);
			query.append("dataID", userLogged?.dataID);
			query.append("search", search);
			query.append("orderBy", orderBy);
			query.append("order", order);
			query.append("page", page);
			query.append("limit", limit);

			Swal.fire({
				footer: 'Loading, please wait',
				showConfirmButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false,
				didOpen: () => {
					Swal.showLoading()
				},
			})
			
			const { data } = await axios.get(`${URI_DASHBOARD_TABLE}?${query.toString()}`, { signal });
			// Guardar respuesta completa en cache local
			setCache(prev => ({ ...prev, [cacheKey]: data }))

			setDashboardTable(data);
		} catch (error) {
			const errorMessage = error.response?.data?.message || "An error occurred while fetching dashboard information.";

			console.error("Error fetching dashboard information: ", errorMessage);
		} finally {
			Swal.close();
		}
	}, [cache]);

	return (
		<section className={`dashboard ${darkLightMode ? "darkMode" : null}`}>
			<div className={`informationList ${loadingInfo ? "loading" : ""}`}>
				{(dashboardInformation?.resumedInformation || INFOCARDS_TITLE)?.map((item, index) => (
					<div key={index} className="informationItem">
						<h3>{item.value}</h3>
						<span>{item.title}</span>
					</div>
				))}
			</div>

			<SuppliersDashboardTable
				data={dashboardTable?.suppliersTableInformation}
				cache={cache}
				onFiltersChange={getDashboardTable}
				totalItems={dashboardTable?.total || 0}
			/>
		</section>
	)
}